/**
 * The palette's matcher: subsequence fuzzy match with word-boundary and
 * prefix bonuses — "hfaq" hits "Access Housing Forecast and Verify FAQ",
 * "9667" hits "TC-9667". Deterministic and cheap (packs are small); score
 * feeds ranking, null = no match.
 */

var WORD_BOUNDARY = /[\s\-_./·]/;
export function fuzzyScore(query, text) {
  var q = query.trim().toLowerCase();
  if (q === '') return 0;
  var t = text.toLowerCase();

  // Whole-substring match dominates everything else.
  var substring = t.indexOf(q);
  if (substring >= 0) {
    return 1000 - substring + (substring === 0 ? 200 : 0) + q.length * 2;
  }

  // Subsequence walk with bonuses for word starts and adjacency.
  var score = 0;
  var ti = 0;
  var lastHit = -2;
  for (var qi = 0; qi < q.length; qi += 1) {
    var ch = q[qi];
    var found = -1;
    while (ti < t.length) {
      if (t[ti] === ch) {
        found = ti;
        break;
      }
      ti += 1;
    }
    if (found === -1) return null;
    if (found === 0 || WORD_BOUNDARY.test(t[found - 1])) score += 12;else if (found === lastHit + 1) score += 8;else score += 1;
    lastHit = found;
    ti = found + 1;
  }
  // Prefer denser matches in shorter strings.
  return score - Math.floor((lastHit - q.length) / 4) - Math.floor(t.length / 20);
}